module.exports = __webpack_public_path__ + "static/img/4.84d34eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/eng/4.png
// module id = ZGAS
// module chunks = 0